module.exports = __webpack_public_path__ + "img/BGStoryOverlay.1ac2c6f7.jpg";